import type { FaireProductEntity } from "../../entity_types/product";

export const p_cv7wtm7ny7: FaireProductEntity = {
  token: "p_cv7wtm7ny7",
  type: "product",
  name: "NAD+ Liquid Drops",
  brandToken: "b_h9v4ts3nzb",
  brandName: "Neurogan Health",
  imageUrl:
    "https://cdn.faire.com/fastly/711826ea2ad664bb31e524449758ecaba0e051a8f1cb3a5106405400da958e54.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5966bcf44992445a70a103c2c06451ea971ebb0441ccfb22293769c597c1dbc9.jpeg",
    "https://cdn.faire.com/fastly/da0cfad2576a6dd19b38edf185fa3c1951002ef976750729398b267634bfe8ad.jpeg",
    "https://cdn.faire.com/fastly/d83ab126fd308939f5392a79ab36d6b8ebc82bbb06010d55bd19acf13d5b9ecf.jpeg",
    "https://cdn.faire.com/fastly/ce00080d5205e090702f947f31ae1acf7d3f18c035ae1aa396c5551a648e4478.jpeg",
    "https://cdn.faire.com/fastly/bc3abbc8d8024c3644382efa972f79d958bf10f6dd46458c011d7ee1eecba7d8.jpeg",
  ],
  priceDollars: 22,
  description:
    "NAD liquid drops provide 300mg to help boost NAD+ levels in the coenzyme. Wild berry flavor, rapid absorption. This liquid bottle includes 18,000mg total, with easy dosing and fast support for your cellular health, energy, and metabolism.\n\nDosage: Shake bottle well. Take 1–2 servings (1ml) in the morning and 1–2 servings (1ml) in the evening for best results. Hold under the tongue for 40–60 seconds before swallowing.\n",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:38.376Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
